
import $ from "jquery";
import React from 'react';
import { Dropdown, Checkbox } from 'semantic-ui-react';

import Add from './add';
import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';


class ExpenseMaster extends React.Component {

  state = {
    expenseMaster: [], menuPermission:[]
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('expense-master', this.props.menus);
    if (menuPermission.view) {
      this.GetExpenseMaster();
    }
    this.setState({ menuPermission })
  }

  GetExpenseMaster() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'WebMaster/ExpenseMaster/get.php',
      success: function(data) {
        console.log(data);
        console.log('ooooooooooooooooooooooooo');
        try {
          data = JSON.parse(data);
          context.setState({ expenseMaster: data, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  activeOptionMenu = (id) => (f, { value }) => {
    if (!this.state.menuPermission.edit) {
      alert('You Are Not Alllow To Edit');
      return;
    }
    let context = this;
    let data = { id, value };
    context.setState({ load: true })
    $.ajax({
      type: 'POST', data: data,
      url: Server() + 'WebMaster/ExpenseMaster/edit.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
            context.GetExpenseMaster();
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }


  toggle = (id, option) => {
    if (!this.state.menuPermission.edit) {
      alert('You Are Not Alllow To Edit');
      return;
    }
    if (option == '1') { option = 0; }
    else { option = 1; }
    let context = this;
    let expenseMaster = this.state.expenseMaster;
    context.setState({ load: true })
    $.ajax({
      type: 'POST', data: { id, option },
      url: Server() + 'WebMaster/ExpenseMaster/changeoption.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
            expenseMaster.map((c) => {
            if (c.id == id) {
              if (c.option == '1') {
                c.option = '0';
              }
              else {
                c.option = '1';
              }
            }
          })
          context.setState({ expenseMaster })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });

    
  }

  render() {
    let { expenseMaster } = this.state;
    let i = 1;
    let activeOption = [
      { key: 'Active', text: 'Active', value: '1' },
      { key: 'Deactive', text: 'Deactive', value: '0' },
    ];
    return (
      <div>
        <Title title={'Expense Master'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div style={{margin: 10}}>
              {
                this.state.menuPermission.add ?
                <Add edit='0' GetExpenseMaster={this.GetExpenseMaster.bind(this)} /> : ''
              }
              
              <Loading load={this.state.load} message={this.state.message} />
              <center>
                <table width="50%" id="table">
                  <tr>
                    <th id='tableheader' style={{ width: '7%' }}>Sino</th>
                    <th id='tableheader'>Expense Name</th>
                    <th id='tableheader'>HSN Code</th>
                    <th id='tableheader'>Tax</th>
                    <th id='tableheader' status={{width: '50%'}}>Action</th>
                    <th id='tableheader'>OtherCharge Option</th>
                    {
                      this.state.menuPermission.edit ?
                      <th id='tableheader'>Edit</th>:''
                    }
                  </tr>
                  { expenseMaster.map((c) => {
                      let checkBox = false;
                      if (c.option == '1') {
                        checkBox = true;
                      }
                      return (
                        <tr>
                          <td><center>{i++}</center></td>
                          <td>{c.name}</td>
                          <td>{c.hsncode}</td>
                          <td>{c.tax}</td>
                          <td>
                            <Dropdown placeholder='Brand' style={{ borderColor: '#5A9CBB' }}
                              search selection onChange={this.activeOptionMenu(c.id)} fluid
                              options={activeOption} value={c.active} /></td>
                          <td>
                            <center>
                              <Checkbox label='' onChange={this.toggle.bind(this, c.id, c.option)}
                                checked={checkBox} />
                            </center>
                          </td>
                          {
                            this.state.menuPermission.edit ?
                            <td><Add edit='1' mid={c.id} name={c.name} item={c}
                                GetExpenseMaster={this.GetExpenseMaster.bind(this)} /></td>:''
                          }
                        </tr>
                      )
                    })
                  }
                </table>
              </center>
            </div>
          ):
          (
            <center>You Are Not Alllow To Access This Menu!!!</center>
          )
        }
      </div>
    );
  }
}

export default ExpenseMaster;
